import { useTranslation } from "react-i18next"

import {
  type TermFacetDescriptor,
  useTermFacetDescriptor,
} from "@/components/search/facet-descriptor"
import { SidebarFacet } from "@/components/search/sidebar-facet"
import { useListingProfileTagMetadata } from "@/components/search/use-listing-profile-tag-metadata"

/** Describes a listing-profile tag facet over the given tag field. */
export function useEducatorProfileFacetDescriptor({
  id,
  field,
}: {
  id: string
  field: string
}): TermFacetDescriptor {
  const { t } = useTranslation("search")
  const tagMetadata = useListingProfileTagMetadata()
  const label = t("facet.educator_profile")

  return useTermFacetDescriptor({
    id,
    config: { type: "terms", field, size: 1000 },
    label,
    pillLabel: (value) =>
      `${t("result.tags")} ${tagMetadata.get(value)?.name ?? value}`,
    searchable: true,
    option: (value, count) => ({
      value,
      count,
      label: tagMetadata.get(value)?.name ?? value,
      description: tagMetadata.get(value)?.categoryName,
      searchTerms: [tagMetadata.get(value)?.categoryName ?? ""],
    }),
  })
}

export function EducatorProfileFacet({
  id,
  field,
}: {
  id: string
  field: string
}) {
  const descriptor = useEducatorProfileFacetDescriptor({ id, field })

  return <SidebarFacet descriptor={descriptor} />
}
